let language = {
    PHOTO_LIB_EDITER_TITLE:"稀有卡",
    PHOTO_LIB_EDITER_DES:"为你的收藏创建最多 10 个稀有卡库。", 
    PHOTO_LIB_EDITER_ADD_RARITY:"添加稀有卡", 
    PHOTO_LIB_EDITER_UPDATE_STORE_PRODUCT_ISSUE:"保存店铺产品失败",
    PHOTO_LIB_EDITER_UPDATE_STORE_PRODUCT_ISSUE_CONTENT:"保存店铺产品时发生问题。 请稍后重试，如果问题仍然存在，请随时与我们的支持团队联系{{supportmail}}."
}
export { language }